/* eslint-disable indent,linebreak-style */
const TABLE_LIMIT = 50;
const tempLevel =!(!process.env.NODE_ENV || process.env.NODE_ENV === 'development');
const tempDate = new Date();
const isDev = false;

let url  = 'http://91.205.173.97:8094/api/admin/';
let socketUrl = 'http://91.205.173.97:2800';

if (!isDev) {
    url = 'https://api.split-deal.com/api/admin/';
    socketUrl = 'https://api.split-deal.com';
}

export default {
    TIME_ZONE: -(tempDate.getTimezoneOffset() / 60),
    DEFAULT_TIME_FORMAT: 'DD-MM-YYYY, HH:mm',
    APP_NAME: 'Deals Buddy - Admin Panel',
    DEFAULT_APP_URL: tempLevel ? url :'http://localhost:8094/api/admin/',
    SOCKET_URL: tempLevel ? socketUrl : 'http://localhost:8094',
    // DEFAULT_APP_URL: 'http://35.154.147.169:5055/api/',
    DEFAULT_PAGE_VALUE: TABLE_LIMIT,
    GOOGLE_LOGIN_KEY: '1027293586426-qg6lv2vsp57m05tn32m9stku2ljsd1uh.apps.googleusercontent.com',
    GOOGLE_MAP_KEY: 'AIzaSyDUTIV7DaCvMUMg3qElE-sxdj4zR-dxhFM',
    FACEBOOK_LOGIN_KEY: '213504989180156',
    DATATABLE_PROPERTIES: {
        title: 'Search',
        height: 'auto',
        selectable: false,
        showRowHover: true,
        columns: [],
        data: [],
        count: 0,
        page: 0,
        showCheckboxes: false,
        // showHeaderToolbar: true,
        rowsPerPage: TABLE_LIMIT,
        rowsPerPageOptions: [],
    },
    DISPUTE_STATUS: {
        ACTIVE: 'ACTIVE',
        REJECTED: 'REJECTED',
        RESOLVED: 'RESOLVED',
    },
    DISPUTE_RESOLUTION: {
        RESOLVED: "RESOLVED",
        DISPUTED: "DISPUTED",
        CANCELLED: "CANCELLED",
        PARTIAL_REFUND: "PARTIAL_REFUND",
    },
    DISPUTE_TEXT: {
        DELIVERABLE_NOT_PROVIDED: 'Deliverables Are Not Provided',
        NO_RESPONSE: 'No Response',
        DELAY: 'Delay In Project',
        CANCEL: 'I want to cancel the job',
        OTHER: 'Other',
        AMEND_DELIVERY_TIME: 'Amend Delivery Time',
        PROJECT_SCOPE: 'Project Scope / Revisions'
    },
    MIME_TYPE: {
        IMAGE: 'IMAGE',
        OTHER: 'OTHER',
    },
    CHAT_DIR: {
        SENDER: 'SENDER',
        RECEIVER: 'RECEIVER',
    },
    APPLIES_TO: {
        ALL: 'ALL',
        CATEGORIES: 'CATEGORIES'
    },
    VISIBLE: {
        'PROVIDER': 'SELLER',
        'SEEKER' : 'BUYER',
        'BOTH' : 'BOTH'
    },
    PRODUCT_TAGS: ['VEG', 'VEGAN', 'GLUTEN FREE', 'DIARY'],
    CURRENCY: 'AED',

    STATUS: {
        'PENDING': 'warning',
        'ACCEPTED': 'success',
        'ACTIVE': 'success',
        'AWARDED': 'success',
        'SUSPENDED': 'error',
        'ALLOTTED': 'success',
        'COMPLETED': 'completed',
        'RESOLVED': 'online'
    },
    JOB_STATUS: {
        PENDING: 'pending',
        ACTIVE: 'success',
        AWARDED: 'awarded',
        ONGOING: 'ongoing',
        DELETED: 'deleted',
        CANCELLED: 'cancelled',
        SUSPENDED: 'suspended',
        UNPUBLISH: 'unpublish',
        COMPLETED: 'completed',
        EXPIRED: 'deleted',
        rejected: 'deleted'
    },
    SPOTLITE_STATUS: {
        PENDING: 'pending',
        ACTIVE: 'success',
        ALLOTTED: 'alloted',
        DELETED: 'deleted',
        SUSPENDED: 'suspended',
        WAITING: 'waiting',
        UNPUBLISH: 'unpublish',
        EXPIRED: 'deleted',
        REJECTED: 'deleted'
    },
    ORDER_STATUS: {
        PENDING: 'PENDING',
        ASSIGNED: 'ASSIGNED',
        PAYMENT: 'PAYMENT',
        ON_PICKUP_LOCATION: 'ON_PICKUP_LOCATION',
        OUT_FOR_DELIVERY: 'OUT_FOR_DELIVERY',
        ON_DROP_LOCATION: 'ON_DROP_LOCATION',
        DELIVERED: 'DELIVERED',
        REJECTED: 'REJECTED',
        ACCEPTED: 'ACCEPTED'
    },
    BOOKING_STATUS_TEXT: {
        PENDING: 'Pending',
        ASSIGNED: 'Assigned',
        REJECTED: 'Rejected',
        ACCEPTED: 'Accepted',
        ALLOTTED: 'Allotted',
        CANCELLED: 'Cancelled'
    },
    ORDER_STATUS_TEXT: {
        ORDER: 'Ordered',
        PENDING: 'Pending',
        ASSIGNED: 'Driver Assigned',
        PAYMENT: 'Payment Pending',
        ON_PICKUP_LOCATION: 'Dispatching',
        OUT_FOR_DELIVERY: 'Out For Delivery',
        ON_DROP_LOCATION: 'Arrived On Location',
        DELIVERED: 'Order Delivered',
        REJECTED: 'Rejected',
        ACCEPTED: 'Accepted'
    },
    ORDER_UPCOMING: [
        'PENDING',
        'ACCEPTED',
    ],
    SOCKET_EVENTS: {
        NEW_ORDER: 'COMPANY_NEW_ORDER',
        ORDER_UPDATE: 'COMPANY_ORDER_UPDATE',
        ORDER_ACCEPTED: 'ORDER_ACCEPTED',
        ORDER_ASSIGNED: 'ORDER_ASSIGNED',
        ORDER_REJECTED: 'ORDER_REJECTED',
        ORDER_ON_PICKUP_LOCATION: 'ORDER_ON_PICKUP_LOCATION',
        ORDER_ON_WAY: 'ORDER_ON_WAY',
        ORDER_ON_DROP_LOCATION: 'ORDER_ON_DROP_LOCATION',
        ORDER_DELIVERED: 'ORDER_DELIVERED',
        ORDER_LOCATION_UPDATE: 'COMPANY_LOCATION_UPDATE',
        ORDER_DATA: 'ORDER_DATA',
        COMPANY_DRIVER_ADD: 'COMPANY_DRIVER_ADD',
        COMPANY_DRIVER_REMOVE: 'COMPANY_DRIVER_REMOVE',
    },
    REFER_POINTS_KEYS: {
        REFER_USER: 'REFER_USER',
        REVIEW: 'REVIEW',
        CONTACT_SYNC_PHONE: 'CONTACT_SYNC_PHONE',
        // CONTACT_SYNC_LINKEDIN: 'CONTACT_SYNC_LINKEDIN',
        CONTACT_SYNC_GMAIL: 'CONTACT_SYNC_GMAIL',
        // CONTACT_SYNC_FACEBOOK: 'CONTACT_SYNC_FACEBOOK',
        RECOMMENDATION: 'RECOMMENDATION',
        UPLOAD_WORK: 'UPLOAD_WORK',
        UPLOAD_CERTIFICATES: 'UPLOAD_CERTIFICATES',
        UPLOAD_VERIFICATION: 'UPLOAD_VERIFICATION',
        POST_FIRST_PROJECT: 'POST_FIRST_PROJECT',
        POST_FIRST_SPOTLITE: 'POST_FIRST_SPOTLITE',
        TOTAL_POINTS: 'TOTAL_POINTS',
    },
    REFER_POINTS_TEXT: {
        REFER_USER: 'Refer a Friend',
        REVIEW: 'Review Person after completion of Project',
        CONTACT_SYNC_PHONE: 'Sync contacts for the first time with phone',
        CONTACT_SYNC_LINKEDIN: 'Sync contacts for the first time with Linkedin',
        CONTACT_SYNC_GMAIL: 'Sync contacts for the first time with Gmail',
        CONTACT_SYNC_FACEBOOK: 'Sync contacts for the first time with Facebook',
        RECOMMENDATION: 'Recommend a friend',
        UPLOAD_WORK: 'Upload his work portfolio',
        UPLOAD_CERTIFICATES: 'Upload his certificates',
        UPLOAD_VERIFICATION: 'Upload verification documents',
        POST_FIRST_PROJECT: 'Post first project',
        POST_FIRST_SPOTLITE: 'Post first spotlite',
        TOTAL_POINTS: 'Total one time points possible',
    },
    BANNER_REDIRECT_SCREEN: {
        // NONE: 'None',
        CHAT_LIST: 'Chat List',
        ARCHIVE_CHATS : 'Archive Chats',
        ACCOUNT: 'Account',
        CATEGORIES: 'Categories',
        NOTIFICATION_SCREEN: 'Notification Screen',
        REFER_AND_EARN: 'Refer & Earn',
    },
    USER_REPORT_TEXT : {
        'OTHER': 'Other',
        'COPYRIGHT_INFRINGEMENT': 'Copyright Infringement',
        'REPORT_SPAM': 'Report Spam',
        'INAPPROPRIATE_CONTENT': 'Inappropriate Content'
    },
    DURATION_TYPE: {
        DAYS: 'DAYS',
        HOURS: 'HOURS'
    },
    DEAL_STATUS: {
        PENDING: 'pending',
        ACTIVE: 'success',
        AWARDED: 'awarded',
        ONGOING: 'ongoing',
        DELETED: 'deleted',
        CANCELLED: 'cancelled',
        SUSPENDED: 'suspended',
        UNPUBLISH: 'unpublish',
        COMPLETED: 'completed',
        EXPIRED: 'deleted',
        rejected: 'deleted'
    },
    DEAL_LOOKING_FOR: {
        BUDDY: 'Buddy',
        SHARE: 'Share',
    },
    DEAL_TYPE: {
        PERCENT_OFF: 'Percent Off',
        // VALUE_OFF: 'Value Off',
        BUY_FREE: 'Buy Free',
        OTHER: 'Other',
    },
    DEAL_PAYMENT_TYPE: {
        SPLIT: 'Split',
        PAY_ME: 'Pay Me',
        PAY_SEPARATE: 'Pay Separate',
        PRE_PAY: 'Pre Pay',
        NO_PAY: 'No Pay',
    },
    REDEEM_TYPE: {
        ONLINE: 'Online',
        IN_STORE: 'In Store',
    },
    DEAL_CONTACT_PREFERENCES: {
        ALL: 'All',
        INTERESTED: 'Interested',
        FOLLOWERS: 'Followers',
    },
};
